export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-fire-line text-background-50"></i>
              </span>
              <span className="text-lg font-bold text-background-50 font-heading">
                51暗网吃瓜
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-50/50">
              51暗网吃瓜是领先的吃瓜视频在线观看平台，整合51吃瓜在线、51cg吃瓜等优质资源，
              提供暗网吃瓜直播与暗网吃瓜视频的每日更新服务。流畅高清、匿名安全，做您最可靠的吃瓜伙伴。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">快速导航</h3>
            <nav className="space-y-2.5">
              <a href="#topics" onClick={(e) => handleNavClick(e, '#topics')} className="block text-sm text-background-50/50 hover:text-accent-400 transition-colors cursor-pointer">热门话题</a>
              <a href="#ranking" onClick={(e) => handleNavClick(e, '#ranking')} className="block text-sm text-background-50/50 hover:text-accent-400 transition-colors cursor-pointer">吃瓜排行</a>
              <a href="#media" onClick={(e) => handleNavClick(e, '#media')} className="block text-sm text-background-50/50 hover:text-accent-400 transition-colors cursor-pointer">视频专区</a>
              <a href="#updates" onClick={(e) => handleNavClick(e, '#updates')} className="block text-sm text-background-50/50 hover:text-accent-400 transition-colors cursor-pointer">最新动态</a>
              <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="block text-sm text-background-50/50 hover:text-accent-400 transition-colors cursor-pointer">常见问题</a>
            </nav>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">内容频道</h3>
            <nav className="space-y-2.5">
              <a href="#cards" onClick={(e) => handleNavClick(e, '#cards')} className="block text-sm text-background-50/50 hover:text-accent-400 transition-colors cursor-pointer">热门速递</a>
              <a href="#index" onClick={(e) => handleNavClick(e, '#index')} className="block text-sm text-background-50/50 hover:text-accent-400 transition-colors cursor-pointer">专题索引</a>
              <a href="#carousel" onClick={(e) => handleNavClick(e, '#carousel')} className="block text-sm text-background-50/50 hover:text-accent-400 transition-colors cursor-pointer">焦点专题</a>
              <a href="#app" onClick={(e) => handleNavClick(e, '#app')} className="block text-sm text-background-50/50 hover:text-accent-400 transition-colors cursor-pointer">移动入口</a>
              <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="block text-sm text-background-50/50 hover:text-accent-400 transition-colors cursor-pointer">联系我们</a>
            </nav>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h3>
            <p className="text-sm text-background-50/40 leading-relaxed">
              合作伙伴信息即将上线，敬请期待。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <span className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-background-50/20 transition-colors">
                <i className="ri-telegram-line text-background-50/60 text-sm"></i>
              </span>
              <span className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-background-50/20 transition-colors">
                <i className="ri-twitter-x-line text-background-50/60 text-sm"></i>
              </span>
              <span className="w-8 h-8 rounded-lg bg-background-50/10 flex items-center justify-center cursor-pointer hover:bg-background-50/20 transition-colors">
                <i className="ri-discord-line text-background-50/60 text-sm"></i>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-50/30">
            &copy; 2026 51暗网吃瓜. 本站内容仅供学习交流，请勿用于商业用途。
          </p>
          <p className="text-xs text-background-50/30">
            51吃瓜在线 · 51cg吃瓜 · 暗网吃瓜视频 · 每日更新
          </p>
        </div>
      </div>
    </footer>
  );
}